// Step 18 — Obligations placeholder.
//
// The backend has no "obligation" domain object today (audited: the
// word only appears as an incidental comment in
// backend/ai_native/buyer_intel/aggregate.py). We include the nav item
// so the future capability can be dropped in without renaming routes,
// but we deliberately DO NOT invent data or metrics that could be
// mistaken for real obligations.

import { AIEmpty, AIPageHeader } from "../shell/AIPrimitives";
import { useAIWorkspace } from "../shell/AIWorkspaceContext";

export default function AIObligations() {
  const { activeWorkspace } = useAIWorkspace();
  return (
    <>
      <AIPageHeader
        title="Åtaganden"
        subtitle={activeWorkspace?.organisation_name}
      />
      <AIEmpty
        title="Åtaganden är inte implementerade ännu"
        hint={
          "När åtaganden (t.ex. SPA-villkor, earn-out-triggers, DD-uppföljning) " +
          "får en egen datamodell dyker de upp här. Fram tills dess spåras de " +
          "under Åtgärder och Avtal."
        }
      />
    </>
  );
}
